<template>
  <span class="sale-status">
    <!-- Exclusiva de plano não é "sem anúncio" (pendência): é decisão de
         cadastro, e cobrar anúncio dela seria alarme falso todo dia. -->
    <b-badge v-if="planOnly" variant="info">{{ $t('catalog.status.plan_only') }}</b-badge>
    <template v-else>
      <b-badge :variant="meta.variant">{{ $t(`catalog.status.${meta.key}`) }}</b-badge>
      <small v-if="priceLabel" class="sale-status-price">{{ priceLabel }}</small>
    </template>
  </span>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import { saleStatusMeta, formatPrice } from './catalog'

/**
 * Situação de venda de um item nas listagens: Publicado / Rascunho /
 * Despublicado / Sem anúncio (+ preço quando houver produto).
 * `sale` é uma linha do GET /products/items/map, ou null.
 */
export default {
  name: 'SaleStatusBadge',
  components: { BBadge },
  props: {
    sale: { type: Object, default: null },
    /** Item que não é vendido avulso (aula exclusiva de plano). */
    planOnly: { type: Boolean, default: false },
  },
  computed: {
    meta() {
      return saleStatusMeta(this.sale)
    },
    priceLabel() {
      if (!this.sale) return null
      const formatted = formatPrice(this.sale.price)
      if (formatted === null) return null
      return Number(this.sale.price) === 0 ? this.$t('catalog.status.free') : formatted
    },
  },
}
</script>

<style lang="scss" scoped>
.sale-status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  white-space: nowrap;
}

.sale-status-price {
  opacity: 0.8;
}
</style>
